var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"redactor-field"},[(_vm.disabled)?_c('div',{staticClass:"redactor-field-field-disabled",domProps:{"innerHTML":_vm._s(_vm.value)}}):_vm._e(),_vm._v(" "),(!_vm.disabled)?_c('redactor',{attrs:{"config":_vm.redactorConfig},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-62f72cd6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/core/Form/Fields/Redactor.vue
// module id = null
// module chunks = 